// extracted by mini-css-extract-plugin
export default {"CodingViewPage__content":"CodingViewPage_CodingViewPage__content__hItV9","CodingViewPage__codeBox":"CodingViewPage_CodingViewPage__codeBox__ISWsQ"};